import {PlayerType} from "@game/coregame/interfaces/PlayerType";

export * from "./math";
export * from "./colors";

export function getOwnerGenerator(
    botsAvailable = [
        PlayerType.Second,
        PlayerType.Third,
        PlayerType.Fourth,
        PlayerType.Fifth,
        PlayerType.Sixth,
        PlayerType.Seventh,
        PlayerType.Eighth
    ]
) {
    return (color: string | null) => {
        const owner = getOwnerTypeByFillColor(color, botsAvailable);
        if (owner > PlayerType.First && owner !== PlayerType.Neutral) {
            botsAvailable.splice(botsAvailable.indexOf(owner), 1);
        }
        return owner;
    };
}
const getOwnerTypeByFillColor = (color: string | null, botsAvailable: PlayerType[]) => {
    switch (color?.toUpperCase()) {
        case "#DE7676":
            // Bot:
            // return Random.from(...botsAvailable);
            return botsAvailable[0];
        case "#74BCFF":
            // Player
            return PlayerType.First;
    }
    return PlayerType.Neutral;
};
